/**
 * Chart timeframes shown in the toolbar.
 *
 * Backend allows 60s…30d (`TokenCandlesQueryDto.intervalMs`). 1m/5m are hidden
 * for now — testnet markets are too thin for those buckets to be useful.
 */
export const KCC20_CHART_INTERVALS = [
  { label: '15m', value: 900_000 },
  { label: '1H', value: 3_600_000 },
  { label: '4H', value: 14_400_000 },
  { label: '1D', value: 86_400_000 },
  { label: '1W', value: 604_800_000 },
] as const;

export type Kcc20ChartIntervalMs =
  (typeof KCC20_CHART_INTERVALS)[number]['value'];

/** First-load timeframe: daily buckets look continuous on thin testnet books. */
export const KCC20_DEFAULT_CHART_INTERVAL_MS: Kcc20ChartIntervalMs = 86_400_000;

/** How many buckets to request per timeframe — denser for intraday. */
export function candleLimitFor(intervalMs: number): number {
  if (intervalMs <= 300_000) return 600;
  if (intervalMs >= 604_800_000) return 160;
  return 400;
}
